<template>
  <div class="container-fluid" style="min-height: 100vh">
    <b-alert
      class="position-fixed fixed-top m-0 rounded-0 text-center"
      fade
      :show="dismissCountDown"
      :variant="errorMessage.color"
      @dismissed="dismissed"
    >
      {{ errorMessage.text }}
    </b-alert>

    <img
      class="position-fixed fixed-top m-0 rounded-0 text-center"
      style="top: 20px; left: 30px"
      src="@/assets/logo.png"
      fluid
      alt="Parceiro CAIXA"
      width="80"
      height="80"
    />

    <div class="row">
      <div class="col-md-4 vh-100" style="border-left: 7px solid #f7941e">
        <div class="d-flex justify-content-center align-items-center h-100">
          <form
            @submit.prevent="loginUser({ email: email, pass: pass })"
            class="mt-3 form-signin"
          >
            <div class="mb-3">
              <h1 class="text-own">Olá! : )</h1>
              <span class="lead"> Entre com a sua conta.</span>
            </div>
            <div class="form-group">
              <input
                autofocus
                v-model="email"
                type="email"
                class="form-control"
                placeholder="Seu email"
              />
            </div>
            <div class="form-group mb-1">
              <input
                v-model="pass"
                type="password"
                class="form-control"
                placeholder="Sua senha"
              />
            </div>
            <div class="clearfix mb-4">
              <a
                class="float-right small recoveryPass"
                href="#"
                @click="recoveryPass({ email: email })"
                >Esqueceu a senha?</a
              >
            </div>
            <button type="submit" class="btn btn-primary btn-block">
              Entrar
            </button>

            <div class="mt-3">
              <span>Que tal fazer parte? </span>
              <router-link to="/register"> Criar a minha conta </router-link>
            </div>
          </form>
        </div>
      </div>
      <div
        class="col-8 d-none d-lg-block"
        style="background-color: #058ce1; border-top-left-radius: 50%"
      >
        <div class="d-flex justify-content-center align-items-center h-100">
          <div class="col-7">
            <div class="position-relative">
              <!-- Browser Device -->
              <figure class="device-browser">
                <div class="device-browser-header">
                  <div class="device-browser-header-btn-list">
                    <span class="device-browser-header-btn-list-btn"></span>
                    <span class="device-browser-header-btn-list-btn"></span>
                    <span class="device-browser-header-btn-list-btn"></span>
                  </div>
                  <div class="device-browser-header-browser-bar">
                    https://app.parceirocaixa.com.br/
                  </div>
                </div>

                <div class="device-browser-frame">
                  <img
                    class="device-browser-img"
                    src="../assets/img/app-parceirocaixa-tela9.png"
                    alt="Image Description"
                  />
                </div>
              </figure>
              <!-- End Browser Device -->
              <div
                class="
                  d-none d-sm-block
                  position-absolute
                  top-80
                  end-0
                  zi-1
                  mb-n5
                  me-n5
                "
                style="max-width: 20rem"
                data-aos="fade-up"
                data-aos-delay="100"
              >
                <!-- Card -->
                <div
                  class="card bg-warning"
                  style="
                    background-image: url(../assets/svg/components/wave-pattern-light.svg);
                  "
                >
                  <!-- <div class="card-body">
                    <h4 class="card-title">Conecte-se rapidamente</h4>
                    <p class="card-text text-dark">
                      A Plataforma permite que você invista seu tempo no
                      desenvolvimento de novas vendas.
                    </p>

                    Avatar -->
                    <!-- <div class="d-flex align-items-center">
                      <div class="flex-shrink-0">
                        <img
                          class="avatar avatar-sm avatar-circle"
                          src="../assets/img/profile_photo.jpeg"
                          alt="Image Description"
                        />
                      </div>
                      <div class="flex-grow-1 ms-2 ml-2">
                        <h5 class="card-title mb-0">Pedro Esteves</h5>
                        <p class="card-text text-dark small">CEO & Founder</p>
                      </div>
                    </div>
                    End Avatar
                  </div> -->
                </div>
                <!-- End Card -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "login",
  data() {
    return {
      email: "",
      pass: "",
    };
  },
  methods: {
    ...mapActions(["loginUser", "recoveryPass", "dismissed"]),
  },
  computed: {
    ...mapState(["error", "errorMessage", "dismissCountDown"]),
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.text-own {
  color: #0f394f;
  font-weight: 700;
}
.form-signin {
  width: 100%;
  max-width: 330px;
  padding: 15px;
  margin: 0 auto;
}
.device-browser {
  /*position: relative;*/
  z-index: 1;
  display: block;
  max-width: 100%;
  width: 50rem;
  height: auto;
  margin-left: auto;
  margin-right: auto;
}
.device-browser-header {
  position: relative;
  display: flex;
  max-width: 50rem;
  background: #fff;
  border-bottom: 0.0625rem solid #f1f3f8;
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
  padding: 0.5rem 6.5rem;
}
.device-browser-header-btn-list {
  display: flex;
  grid-gap: 0.25rem;
  position: absolute;
  top: calc(50% - 0.25rem);
  left: 1rem;
}
.device-browser-header-btn-list-btn {
  width: 0.5rem;
  height: 0.5rem;
  background-color: #e7eaf3;
  border-radius: 50%;
}
.device-browser-header-browser-bar {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  color: #677788;
  background-color: #e7eaf3;
  font-size: 0.5rem;
  border-radius: 0.125rem;
}
.device-browser-frame {
  background: #fff;
  box-shadow: 0 2.75rem 5.5rem -3.5rem rgb(189 197 209 / 50%),
    0 2rem 4rem -2rem rgb(33 50 91 / 30%);
  border-bottom-right-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}
.device-browser-img {
  max-width: 100%;
  height: auto;
  border-bottom-right-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}
img,
svg {
  vertical-align: middle;
}
.card {
  border-width: 0;
  box-shadow: 0rem 0.375rem 1.5rem 0rem rgb(140 152 164 / 13%);
}
.card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 0.0625rem solid rgba(33, 50, 91, 0.1);
  border-radius: 0.5rem;
}
.zi-1 {
  z-index: 1 !important;
}
.mb-n5 {
  margin-bottom: -2rem !important;
}
.me-n5 {
  margin-right: -2rem !important;
}
.end-0 {
  right: 0 !important;
}
.top-80 {
  top: 80px !important;
}
</style>
